import React from 'react';
import { styled } from '@glitz/react';
import ArticleListItemViewModel from 'Shared/ViewModels/ContentListItemViewModel.type';
import ArticleCard from './ArticleCard';
import { createGridClasses } from 'Shared/grid';

type PropType = {
  articles: ArticleListItemViewModel[];
  isCompact: boolean;
};

const MoreArticles = ({ articles, isCompact }: PropType) => {
  return (
    <styled.Div
      className="grid"
      css={{ gap: '16px' }}
    >
      {articles.map((article, index) => (
        <styled.Div key={`article-${index}`} className={createGridClasses(12, 6)}>
          <ArticleCard article={article} />
        </styled.Div>
      ))}
    </styled.Div>
  );
};

export default MoreArticles;
